const COMMON = {
  INFORMATION: {
    light: "/svg/common/information_light.svg",
    dark: "/svg/common/information_dark.svg",
  },
  EDIT_PENCIL: {
    dark: "/svg/common/edit_pencil.svg",
  },
  MORE_DOTS: {
    dark: "/svg/common/more_dots.svg",
  },
  CLONE: {
    dark: "/svg/common/clone.svg",
  },
  DELETE: {
    dark: "/svg/common/delete.svg",
  },
  ARROW_DOWN: {
    dark: "/svg/common/arrow_down.svg",
  },
  WARNING: {
    yellow: "/svg/common/warning_icon_yellow.svg",
  },
};

export default COMMON;
